var GlobalSearchInput_types_GlobalSearchInputSize = /*#__PURE__*/ function(GlobalSearchInputSize) {
    GlobalSearchInputSize["large"] = "large";
    GlobalSearchInputSize["medium"] = "medium";
    return GlobalSearchInputSize;
}({});
export { GlobalSearchInput_types_GlobalSearchInputSize as GlobalSearchInputSize };
